export default __webpack_public_path__ + "static/media/icon-arrow-down.939e8dad.svg";